export const padTo2Digits = (num) => {
    return num.toString().padStart(2, '0');
};
